import { BACKEND_BASE_URL } from "@/services";
import Vue from "vue";
import { UserPreferencesService } from "./userPreferences.types";
import { RawUserPreferencesReport, UserPreferencesReport } from "@/entities/user-preferences-report";

export class UserPreferencesServiceImpl implements UserPreferencesService {
  async fetchUserPreferencesV2(): Promise<UserPreferencesReport> {
    const url = `${BACKEND_BASE_URL}/api/v2/me/userpreferences`;
    const { data } = await Vue.$axios.get<RawUserPreferencesReport>(url);
    return new UserPreferencesReport(data);
  }
  async saveUserPreferencesV2(userPreferences: UserPreferencesReport): Promise<void> {
    const url = `${BACKEND_BASE_URL}/api/v2/me/userpreferences`;
    const body = userPreferences;
    await Vue.$axios.put(url, body);
  }
}
